import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceStandardDetailPage } from "@/components/workspace-standards/WorkspaceStandardDetailPage";

export const Route = createFileRoute("/$workspaceSlug/standards/$standardId")({
  component: WorkspaceStandardDetailPage,
});
